// Rascunhos de notas no localStorage — camada "à prova de balas" do autosave.
// Cada alteração no editor é gravada aqui ANTES de ir ao servidor. Se internet
// ou servidor falharem (ou o navegador fechar), o rascunho fica pendente e é
// sincronizado automaticamente depois.

const PREFIX = "linkia_note_draft:";

function key(id) {
    return PREFIX + id;
}

export function saveDraft(id, data) {
    if (!id) return;
    try {
        localStorage.setItem(key(id), JSON.stringify({ ...data, savedAt: Date.now() }));
    } catch {
        // localStorage cheio/indisponível — o autosave no servidor continua valendo
    }
}

export function getDraft(id) {
    if (!id) return null;
    try {
        const raw = localStorage.getItem(key(id));
        return raw ? JSON.parse(raw) : null;
    } catch {
        return null;
    }
}

export function removeDraft(id) {
    if (!id) return;
    try {
        localStorage.removeItem(key(id));
    } catch { /* ignore */ }
}

export function listDrafts() {
    const out = [];
    try {
        for (let i = 0; i < localStorage.length; i++) {
            const k = localStorage.key(i);
            if (!k || !k.startsWith(PREFIX)) continue;
            const raw = localStorage.getItem(k);
            if (!raw) continue;
            try {
                out.push({ draftId: k.slice(PREFIX.length), ...JSON.parse(raw) });
            } catch { /* rascunho corrompido — ignora */ }
        }
    } catch { /* ignore */ }
    return out;
}
